import { PortalUrl } from './Models/Environments'

/**
 * @private-doc
 */
export class PortalUrlProvider {
  static PortalUrl: string = ''
  /*static get IframeApprovalUrl():string{
        return `${PortalUrl}/ecportalapproval`;
    }
    static get ApprovalUrl():string{
        return `${PortalUrl}/ecportal`;
    }*/
}
